import { X } from "lucide-react";
import type { ReactNode } from "react";

import { IgIconButton } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

import { useExecutionPanelContext } from "../ExecutionPanelContext";

export const ExecutionPanelCloseButton = () => {
  const {
    onClose,
    closeIcon,
    closeLabel = "Close AI chat",
  } = useExecutionPanelContext();
  if (!onClose) return null;

  return (
    <ExecutionPanelCloseButtonView
      closeIcon={closeIcon}
      closeLabel={closeLabel}
      onClose={onClose}
    />
  );
};

export const ExecutionPanelCloseButtonView = ({
  closeIcon,
  closeLabel,
  onClose,
}: {
  closeIcon?: ReactNode;
  closeLabel: string;
  onClose: () => void;
}) => {
  const theme = useTheme();

  return (
    <Grid>
      <IgIconButton
        aria-label={closeLabel}
        onClick={onClose}
        sx={{
          color: theme.palette.text.secondary,
          minHeight: 44,
          minWidth: 44,
          "&:hover": {
            backgroundColor: theme.igBackgroundColors.baseLightMid,
          },
        }}
      >
        {closeIcon ?? <X size={20} />}
      </IgIconButton>
    </Grid>
  );
};
